import { IEhancedAddProductViewContainer } from './EhancedAddProductViewContainer'
import EhancedAddProductViewContainerLazy from './EhancedAddProductViewContainerLazy'
export default EhancedAddProductViewContainerLazy
export type { IEhancedAddProductViewContainer }
